import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requireAnyPermission, requireModule } from '../../../app/guards'

export const Route = createFileRoute('/_app/serials')({
  staticData: { crumb: 'serials' },
  // Serials are stock: the API refuses them while Inventory is off, whoever may read products.
  beforeLoad: ({ context }) => {
    requireModule(context.session, 'inventory')
    requireAnyPermission(context.session, 'inventory.read', 'products.read')
  },
  component: Outlet,
})
